<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">
        {{ $t('stockTransfer.serial') }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div class="ts-mt-3 max-h ts-rounded ts-overflow-y-scroll">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                style="width: 14%"
              >
                {{ $t('stockTransfer.barcode') }}
              </th>
              <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                {{ $t('stockTransfer.group') }}
              </th>
              <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                {{ $t('stockTransfer.product') }}
              </th>
              <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                {{ $t('stockTransfer.status') }}
              </th>
              <th
                class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                style="width: 9%"
              >
                {{ $t('stockTransfer.serial') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(serial, index) in serialResource" :key="index">
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                {{ data.product.barcode }}
              </td>
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                {{ data.product.pro_group_name_en }}
              </td>
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                {{ data.product.product_name_kh ? data.product.product_name_kh : data.product.product_name_en }}
              </td>
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                <span
                  :class="'text-' + serialStatusStyle(serial.sn_status_id)"
                  >{{
                    serial.serial_status ? serial.serial_status.sn_status : ''
                  }}</span
                >
              </td>
              <td class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap">
                {{ serial.serial_no }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ts-mt-1 ts-mr-2 ts-text-right ts-font-bold text-danger">
        TOTAL : {{ serialResource.length }}
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'showSerial',
  props: ['data'],
  data () {
    return {
      waiting: false,
      status_id: 1,
      datasource: []
    }
  },
  computed: {
    serialResource () {
      return this.data.stock_transfer_detail_serial
    },
    serialStatusStyle: () => sn_status_id => {
      let value = ''

      switch (sn_status_id) {
        case 1:
          value = 'primary'
          break
        case 2:
          value = 'warning'
          break
        case 3:
          value = 'success'
          break
      }

      return value
    }
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
.max-h {
  max-height: 50vh;
}
</style>
